const data = {
	"width": 24,
	"height": 24,
	"body": "<circle cx=\"4\" cy=\"12\" r=\"1.5\" fill=\"currentColor\"><animate attributeName=\"r\" dur=\"0.75s\" repeatCount=\"indefinite\" values=\"1.5;3;1.5\"/></circle><circle cx=\"12\" cy=\"12\" r=\"3\" fill=\"currentColor\"><animate attributeName=\"r\" dur=\"0.75s\" repeatCount=\"indefinite\" values=\"3;1.5;3\"/></circle><circle cx=\"20\" cy=\"12\" r=\"1.5\" fill=\"currentColor\"><animate attributeName=\"r\" dur=\"0.75s\" repeatCount=\"indefinite\" values=\"1.5;3;1.5\"/></circle>"
};
exports.__esModule = true;
exports.default = data;
